import React from 'react';
import './SimpleTextField.css';

function SimpleTextField({
  label = 'Campaign Name',
  placeholder = 'Enter campaign name',
  labelPosition = 'top-left',
  wrapperClassName = '',
  inputClassName = '',
  id,
  customWidth,
  value,
  setValue,
  allowOnlyInteger = false,
  ...inputProps
}) {
  const inputId = id || `stf-input-${Math.random().toString(36).slice(2, 9)}`;

  const handleChange = (e) => {
    let val = e.target.value;

    if (allowOnlyInteger) {
      // Remove all non-digit characters
      val = val.replace(/[^0-9]/g, '');
    }

    setValue({ target: { value: val } });
  };

  return (
    <div
      className={[
        'stf-wrap',
        `stf-label-pos-${labelPosition}`,
        wrapperClassName,
      ].join(' ')}
      style={{
        width: customWidth || '100%',
        maxWidth: customWidth || '100%',
      }}
    >
      <label htmlFor={inputId} className="stf-label">
        {label}
      </label>
      <input
        id={inputId}
        type="text"
        value={value}
        placeholder={placeholder}
        className={['stf-input', inputClassName].join(' ')}
        onChange={handleChange}
        {...inputProps}
      />
    </div>
  );
}

export default SimpleTextField;
